module.exports = __webpack_public_path__ + "img/yuanxi-logo.8c00d212.png";